var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 0.3125,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#090909"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 29.3125C24.9706 29.3125 29 25.2831 29 20.3125C29 15.3419 24.9706 11.3125 20 11.3125C15.0294 11.3125 11 15.3419 11 20.3125C11 25.2831 15.0294 29.3125 20 29.3125ZM20 31.3125C26.0751 31.3125 31 26.3876 31 20.3125C31 14.2374 26.0751 9.3125 20 9.3125C13.9249 9.3125 9 14.2374 9 20.3125C9 26.3876 13.9249 31.3125 20 31.3125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7148 27.2631C22.4765 25.5873 23 23.1318 23 20.3125C23 17.4932 22.4765 15.0377 21.7148 13.3619C20.871 11.5056 20.1142 11.3125 20 11.3125C19.8858 11.3125 19.129 11.5056 18.2852 13.3619C17.5235 15.0377 17 17.4932 17 20.3125C17 23.1318 17.5235 25.5873 18.2852 27.2631C19.129 29.1194 19.8858 29.3125 20 29.3125C20.1142 29.3125 20.871 29.1194 21.7148 27.2631ZM20 31.3125C22.7614 31.3125 25 26.3876 25 20.3125C25 14.2374 22.7614 9.3125 20 9.3125C17.2386 9.3125 15 14.2374 15 20.3125C15 26.3876 17.2386 31.3125 20 31.3125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 18.3125H10V16.3125H29V18.3125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 24.3125H10V22.3125H29V24.3125Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.6cd05b8c.svg";
export { ForwardRef as ReactComponent };